export enum OAuth2MicrosoftPrompt {
    None = 'none',
    Login = 'login',
    Consent = 'consent',
    SelectAccount = 'select_account',
}
